var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBirebirKocluk = function SvgBirebirKocluk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_4041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8706 147.027C28.5283 141.701 24.2885 135.374 21.3937 128.408C18.4988 121.442 17.0058 113.974 17 106.431C16.9942 98.8871 18.4757 91.4164 21.3598 84.446C24.2439 77.4756 28.474 71.1422 33.8081 65.8081C39.1422 60.474 45.4756 56.2439 52.446 53.3598C59.4164 50.4757 66.8871 48.9942 74.4306 49C81.9741 49.0058 89.4425 50.4988 96.4084 53.3937C103.374 56.2885 109.701 60.5283 115.027 65.8706L230.69 181.533L169.934 242.289C158.665 253.558 140.4 253.558 129.132 242.289L33.8706 147.027Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.377 181.533L184.039 65.8706C189.365 60.5283 195.692 56.2885 202.658 53.3937C209.624 50.4988 217.093 49.0058 224.636 49C232.18 48.9942 239.65 50.4757 246.621 53.3598C253.591 56.2439 259.924 60.474 265.259 65.8081C270.593 71.1422 274.823 77.4756 277.707 84.446C280.591 91.4164 282.072 98.8871 282.067 106.431C282.061 113.974 280.568 121.442 277.673 128.408C274.778 135.374 270.538 141.701 265.196 147.027L169.935 242.289C158.665 253.558 140.401 253.558 129.132 242.289L68.377 181.533Z",
    fill: "url(#paint0_linear_4330_4041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.618 163.836C256.311 163.836 282.004 138.143 282.004 106.449C282.004 74.7558 256.311 49.063 224.618 49.063C192.924 49.063 167.231 74.7558 167.231 106.449C167.231 138.143 192.924 163.836 224.618 163.836Z",
    fill: "#2B81FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4041",
    x1: 282.029,
    y1: 49.0092,
    x2: 80.6629,
    y2: 262.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_4041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
};
export default SvgBirebirKocluk;